import { Button, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import { Dialogs, useDialogs } from '../../Contexts/DialogsContext'
import { useGlobalContext } from '../../Contexts/GlobalContext'
import BaseDialog from '../Common/BaseDialog'
import HorseIcon from '../Icons/horse'
import SignIn from './SignIn'
import SignUp from './SignUp'

export enum ErrorAction {
    GUEST_REGISTRATION = 'guestRegistration',
    SOCIAL_LOGIN = 'socialLogin',
}

interface ErrorProps {
    errorAction: ErrorAction | null
}

const Error: React.FC<ErrorProps> = (props) => {
    const { errorAction } = props
    const { onAuthClose } = useGlobalContext()
    const { registerDialog, unregisterDialog } = useDialogs()

    const onOpenSignInDialog = () => {
        unregisterDialog(Dialogs.ERROR)
        registerDialog(Dialogs.SIGNIN, <SignIn />)
    }

    const onErrorTryAgain = () => {
        switch (errorAction) {
            case ErrorAction.GUEST_REGISTRATION:
                onAuthClose()
                break
            case ErrorAction.SOCIAL_LOGIN:
                unregisterDialog(Dialogs.ERROR)
                registerDialog(Dialogs.SIGN_UP_SOCIAL, <SignUp isSocialSignup />)
                break
            default:
                break
        }
    }

    return (
        <BaseDialog name={Dialogs.ERROR} title="OOOPS!" horizontalCentered onClose={onAuthClose} forceBlock>
            <HorseIcon />
            <Typography variant="body1">An unknown error has occurred. Please try again!</Typography>
            <Button size="large" fullWidth variant="contained" onClick={onErrorTryAgain}>
                Try again
            </Button>
            <Stack direction="row" gap={1} alignItems="center" justifyContent="center">
                <Typography variant="body1">Already have an account?</Typography>
                <Link variant="body1" onClick={onOpenSignInDialog}>
                    Log in
                </Link>
            </Stack>
        </BaseDialog>
    )
}

export default Error
